module.exports = __webpack_public_path__ + "media/OriTor_Hero.e69271e6.mp4";